import { render, staticRenderFns } from "./problemDetail.vue?vue&type=template&id=8e1c418c&scoped=true"
import script from "./problemDetail.vue?vue&type=script&lang=js"
export * from "./problemDetail.vue?vue&type=script&lang=js"
import style0 from "./problemDetail.vue?vue&type=style&index=0&id=8e1c418c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1c418c",
  null
  
)

export default component.exports